import { CHECKOUT_ITEM_TYPE_TOUR_V2 } from 'constants/checkout'
import extractTourV2PurchasableOptionDetails from 'lib/tours/extractTourV2PurchasableOptionDetails'
import { getItemUniqueKey, getPackageId } from '../accommodation/cart'
import { getPackageOptionType } from 'lib/tours/tourUtils'
import { OFFER_TYPE_TOUR_V2 } from 'constants/offer'

export function isTourOfferViewWithPackageUpgrade(
  view: App.Checkout.AccommodationOfferView,
): view is App.Checkout.TourV2AccommodationOfferView {
  return view.offerType === OFFER_TYPE_TOUR_V2 && view.itemViews.some((item) => !!item?.packageOptionInclusion)
}

function dummyAccommodationItemView(
  item: App.Checkout.TourV2Item,
  kind: 'tourV2',
): App.Checkout.TourV2AccommodationItemView {
  return {
    kind,
    packageId: getPackageId(item),
    uniqueKey: getItemUniqueKey(item),
    item,
    mainLabel: '',
    occupancy: { adults: 0, children: 0 },
    removeLabel: 'Remove',
    price: 0,
    value: 0,
    surcharge: 0,
    taxesAndFees: 0,
  }
}

export function getTourV2ItemView(
  item: App.Checkout.TourV2Item,
  offer?: Tours.V2Offer,
): App.WithDataStatus<App.Checkout.TourV2AccommodationItemView> {
  if (!offer) {
    return {
      hasRequiredData: false,
      data: dummyAccommodationItemView(item, CHECKOUT_ITEM_TYPE_TOUR_V2),
    }
  }

  const {
    roomTypeName,
    pricePerPerson,
    valuedAt,
  } = extractTourV2PurchasableOptionDetails(item.purchasableOption)

  const variation = offer.variations[item.purchasableOption.fkVariationId]
  const packageOptionInclusion = variation?.availablePackageUpgrades?.find(
    packageUpgrade => packageUpgrade.packageOption.toLowerCase() === getPackageOptionType(item.purchasableOption.roomType!),
  )

  return {
    hasRequiredData: true,
    data: {
      kind: CHECKOUT_ITEM_TYPE_TOUR_V2,
      packageId: item.purchasableOption.fkDepartureId,
      uniqueKey: item.purchasableOption.fkDepartureId,
      item,
      mainLabel: roomTypeName ?? '',
      occupancy: item.occupancy,
      removeLabel: 'Remove room',
      price: pricePerPerson,
      value: valuedAt?.price,
      surcharge: 0,
      taxesAndFees: 0,
      variation,
      packageOptionInclusion,
    },
  }
}
